<div class="page">
    <h1 class="page-title">
        Personal Info
    </h1>
    <p-card>
        <div class="d-flex gap-2 flex-wrap">
            <div class="profile-wrapper">
                <label for="profileInput" class="profile-circle">
                  <!-- <img [src]="profileImageUrl" alt="Profile" /> -->
                  <img [src]="profileImageUrl" alt="Profile" />
                </label>
                <div class="camera-icon">
                    <img src="../../../../assets/icons/camera-fill.svg" alt="">
                </div>
              
                <input 
                  type="file" 
                  id="profileInput" 
                  hidden 
                  (change)="onFileSelected($event)"
                />
              </div>
            <div class="input-container">
                <label for="">First Name</label>
                <input type="text" placeholder="Enter your name">
                <!-- <app-form-errors [control]="loginForm.controls['email']"></app-form-errors> -->
            </div>
            <div class="input-container">
                <label for="">Last Name</label>
                <input type="text" placeholder="Enter your last name">
                <!-- <app-form-errors [control]="loginForm.controls['email']"></app-form-errors> -->
            </div>
        </div>

        <div class="inputs-group-container mt-3">
            <div class="input-container">
                <label for="">Email</label>
                <input type="email" placeholder="Enter your Email">
                <!-- <app-form-errors [control]="loginForm.controls['email']"></app-form-errors> -->
            </div>
            <div class="input-container">
                <label for="">Phone Number</label>
                <input type="tel" placeholder="phone number">
                <!-- <app-form-errors [control]="loginForm.controls['email']"></app-form-errors> -->
            </div>
        </div>
        <div class="input-container mt-3">
            <label for="">Company</label>
            <input type="text" placeholder="Company">
            <!-- <app-form-errors [control]="loginForm.controls['email']"></app-form-errors> -->
        </div>
    </p-card>

    <p-card class="mt-4">
        <h1 class="card-title">
            Billing Information
        </h1>
        <p class="card-description">Manage your payment methods and billing details</p>

        <div class="payment-method-card">
            <div class="card-info">
                <img src="../../../../assets/icons/mastercard.svg" alt="Mastercard" class="card-icon" />
                <div class="card-details">
                    <span class="card-number">•••• •••• •••• 4242</span>
                    <span class="card-expiry">Expires 12/25</span>
                </div>
            </div>
        </div>

        <button pButton class="add-payment-btn p-button-outlined mt-3">
            Add Payment Method
        </button>

        <h2 class="billing-address-title mt-4">Billing Address</h2>

        <div class="inputs-group-container mt-3">
            <div class="input-container">
                <label for="">Street Address</label>
                <input type="text" placeholder="Enter street address" value="123 Main Street">
            </div>
            <div class="input-container">
                <label for="">City <span class="required">*</span></label>
                <input type="text" placeholder="Enter city" value="Riyadh">
            </div>
        </div>
        <div class="inputs-group-container mt-3">
            <div class="input-container">
                <label for="">State</label>
                <input type="text" placeholder="Enter state" value="NY">
            </div>
            <div class="input-container">
                <label for="">Zip Code</label>
                <input type="text" placeholder="Enter zip code" value="2345">
            </div>
        </div>

        <button pButton class="custom-btn linear-blue mt-4">
            Update Billing Information
        </button>
    </p-card>

    <p-card class="mt-4">
        <h1 class="card-title">
            Recent Invoices
        </h1>
        <p class="card-description">Download your recent billing statements</p>
        <div class="invoices-list">
            @for(invoice of invoices; track $index){
            <div class="invoice-card">
                <div class="invoice-info">
                    <div class="invoice-header">
                        <span class="invoice-date">{{invoice?.date}}</span>
                        <span class="status-badge" [ngClass]="invoice?.status?.toLowerCase()">
                            {{invoice?.status}}
                        </span>
                    </div>
                    <span class="invoice-amount"> {{invoice?.total | number:'1.2-2'}} SAR </span>
                </div>
                <button class="download-btn" pButton>
                    <i class="pi pi-download"></i>
                    Download
                </button>
            </div>
            }
        </div>
    </p-card>
</div>